import type { FaireProductEntity } from "../../entity_types/product";

export const p_vgfw7ygy8v: FaireProductEntity = {
  token: "p_vgfw7ygy8v",
  type: "product",
  name: "Desert Heights Luxury Non-toxic Candle",
  brandToken: "b_rp9e5zdxjc",
  brandName: "Wilkin & May",
  imageUrl:
    "https://cdn.faire.com/fastly/4617339809af6e2aee04e50c93ec36ef7fa724a00c8ac159f49a989d49adc8c9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6101b3683638c010bbc6c169141b1ab4851bdfec4a601d0805cb3237378e05b.png",
    "https://cdn.faire.com/fastly/4ce55e4d4bf054d0888c5a636d2009eaf29f94e2ab8d3bda8914e96ca8d21f70.png",
    "https://cdn.faire.com/fastly/ac186b24f7483532bfa3cfa674aa0784da753b88985de5c084afd5dfafa88af7.jpeg",
  ],
  priceDollars: 24,
  description:
    " Like the stillness of a sun-warmed desert at dawn. \n\nDesert Heights is earthy, clean, and quietly grounding. Dry cedarwood and sun-warmed pinyon pine form a crisp, resilient base, while soft sage and mineral notes bring subtle freshness. The result is a scent that feels rooted, calm, and effortlessly sophisticated—perfect for creating a serene, inviting atmosphere. \n\nEvery detail is designed to feel intentional: hand-poured in small batches, a clean coconut wax blend for an elegant burn, and a vessel meant to live on long after the flame. Even the wax itself is skin-safe, melting into a balm you can carry beyond the room.\n\nDetails:\n\n- Hand-poured in Ojai, California in small batches\n- Clean-burning coconut wax blend\n- Skin-safe wax doubles as a nourishing balm\n- 40+ hour burn time\n- Lead-free cotton wick\n- Reusable glass vessel\n- Phthalate-free, paraben-free and cruelty-free\n- Sustainable, biodegradable wax and packaging\n- Fragrance oils infused with natural botanicals\n- Ideal for spa retail, yoga studios, meditation spaces, wellness shops, gift boutiques and home goods stores\n\nLuxury positioning: desert-inspired, grounding, clean, tranquil and gift-worthy.",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:57.005Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
